import Dropdown from "rc-dropdown"
import { FC, useState } from "react"

interface PopoverOverlayProps {
    name: string
}

const PopoverOverlay: FC<PopoverOverlayProps> = ({ name }) => {
    return (
        <div className="py-2 px-3 rounded-lg bg-slate-800 text-white"> 
            {name}
        </div>
    )
}

interface TransporterIconProps {
    name: string
    icon: string
}

export const TransporterIcon: FC<TransporterIconProps> = ({ name, icon }) => {
    const [imageLoaded, setImageLoaded] = useState<boolean>(false)

    return (
        <Dropdown 
            trigger={"hover"}
            overlay={<PopoverOverlay name={name}/>}
            placement="top"
        >
            <div className="w-10 p-[2px] rounded-full overflow-hidden h-10 bg-slate-100">
                <img 
                    className={`transition-all w-full h-full object-contain ${imageLoaded ? "opacity-100": "opacity-0"}`}
                    src={icon} 
                    onLoad={() => setImageLoaded(true)}  
                />
            </div>
        </Dropdown>
    )
}